<ca-modal-container modalTitle="Share Result" (dismiss)="dismiss($event)">
    <div class="container">
        <div class="row">
            <span class="text col-md-6 padding-left-zero text-center">Shareable link for your result</span>
            <div class="col-md-6 mt-4 mb-4">
                <div class="input-group">
                    <input #urlTextBox class="url-input form-control" type="text" [value]="shareLink" readonly data-uit="result-share-modal-url-input" />
                    <button
                        (cbOnSuccess)="t.open()"
                        [ngbTooltip]="'GENERAL.TEXT_COPIED' | translate"
                        [ngxClipboard]="urlTextBox"
                        [title]="'GENERAL.COPY_URL_TO_CLIPBOARD' | translate"
                        #t="ngbTooltip"
                        class="btn btn-secondary"
                        container="body"
                        triggers="manual"
                        type="button"
                    >
                        <ca-icon name="copy" size="s"></ca-icon>
                    </button>
                </div>
            </div>
        </div>
        <span class="row text share-text">How would you like to share the link for your result?</span>
        <div class="row share-buttons-container mt-3 d-flex justify-content-start">
            <button type="button" class="btn-primary btn mt-2 me-3" caAutoFocus (click)="openEmail()"><ca-icon name="envelope" size="s"></ca-icon>Mail</button>
            <button type="button" class="btn-secondary btn mt-2" (click)="openTwitter()"><ca-icon name="twitter" size="s"></ca-icon>Tweet</button>
        </div>
    </div>
</ca-modal-container>
